export default __webpack_public_path__ + "static/media/Helm of Reckless Challenge.b9ee2507.jpg";